import { makeAutoObservable } from 'mobx'

/**
 * Shared flag for the cross-tab account-hijack case.
 *
 * The token is stored in localStorage (shared across tabs), so logging into a
 * second account in another tab overrides the token this tab is using. Both the
 * realtime storage listener (Method 1) and the pre-action guard (Method 2) flip
 * this flag, which the AccountConflictModal observes to block the UI.
 */
class StoreAccountConflict {
    isConflict = false

    constructor() {
        makeAutoObservable(this)
    }

    Trigger() {
        this.isConflict = true
    }

    Reset() {
        this.isConflict = false
    }

    IsConflict() {
        return this.isConflict
    }
}

const storeAccountConflict = new StoreAccountConflict()
export default storeAccountConflict
